export default "__VITE_ASSET__DHT7N5cW__"